<template>
  <div class="tags-input">
    <div class="tags">
      <span v-for="(tag, index) in tags" :key="index" class="tag">
        {{ tag }}
        <span class="remove-tag" @click="removeTag(index)">
          <app-icon name="x"/>
        </span>
      </span>
    </div>

    <input
        type="text"
        v-model="newTag"
        @keydown.enter.prevent="addTag"
        placeholder="Add a tag"
        class="tag-input"
    />
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => []  // Provide default value as an empty array
    },
    placeholder: {
      type: String,
      default: "Add a tag"  // Provide default value as an empty array
    },
    id: {
      type: String,
      required: true  // Provide default value as an empty array
    },
    data: {
      type: Object,
      default: () => ({}) // Provide a default empty object
    },
  },
  data() {
    return {
      newTag: '',              // Input for new tags
      internalTags: []  // Internal tags array to manage state
    };
  },
  methods: {
    // Add tag to the list
    addTag() {
      // Check if the tag is not empty and not already added
      // if (this.newTag.trim() !== '' && !this.tags.includes(this.newTag.trim())) {
      //   this.tags.push(this.newTag.trim()); // Add new tag
      //   this.$emit('update-tags', this.tags); // Emit event when tags are updated
      // }
      // this.newTag = ''; // Clear input
      if (this.newTag.trim() !== '' && !this.internalTags.includes(this.newTag.trim())) {
        this.internalTags.push(this.newTag.trim()); // Add new tag
        this.$emit('update-tags', this.internalTags); // Emit event
      }
      this.newTag = ''; // Clear input
    },
    // Remove tag from the list
    removeTag(index) {
      // this.tags.splice(index, 1); // Remove the tag at index
      // this.$emit('update-tags', this.tags); // Emit event when tags are updated
      this.internalTags.splice(index, 1); // Remove tag
      this.$emit('update-tags', this.internalTags); // Emit event
    }
  },
  // created: {
  //   internalTags: {
  //     handler(newTags) {
  //       this.internalTags = [newTags];
  //     }
  //   }
  // },
  watch: {
    // Watch for changes to the tags prop and update internalTags
    tags: {
      immediate: true,  // Populate internalTags immediately with prop data
      handler(newTags) {
        this.internalTags = [...newTags];
      }
    }
  },
};
</script>

<style scoped>
.tags-input {
  border: 1px solid var(--default-border-color) !important;
  padding: 5px;
  border-radius: 5px;
  display: inline-block;
  width: 100%;
  color: var(--default-font-color);
}

.tags {
  display: flex;
  flex-wrap: wrap;
}

.tag {
  background-color: var(--form-control-bg);
  color: var(--default-font-color);
  padding: 5px;
  border-radius: 3px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  border-color: var(--default-border-color) !important;
  border: 1px solid;
}

.remove-tag {
  margin-left: 5px;
  cursor: pointer;
  /*color: #464f60;*/
  color: var(--default-font-color);
}

.tag-input {
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 5px;
  background-color: var(--form-control-bg);
  width: 100%;
  color: var(--default-font-color);
}
</style>
